import { render, staticRenderFns } from "./ph-news.vue?vue&type=template&id=1a72d0d0"
import script from "./ph-news.vue?vue&type=script&lang=js"
export * from "./ph-news.vue?vue&type=script&lang=js"
import style0 from "./ph-news.vue?vue&type=style&index=0&id=1a72d0d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports